<app-table (refreshClicked)="this.refresh()"
  (searchQueryChange)="this.refresh()"
  [(searchQuery)]="searchQuery"
  [columns]="this.columns"
  [maximumNumberOfResultsPerPage]="this.maximumNumberOfResultsPerPage"
  [numberOfResultsReturned]="this.numberOfResultsReturned"
  [page]="this.page"
  [state]="this.tableState"
  [totalNumberOfResults]="this.totalNumberOfResults"
  >
  @if (this.tableState === TableStateEnum.NoData) {
    <tbody class="no-data p-4">
      <tr>
        <td [colSpan]="columns.length" class="text-center">
          <img src="/assets/images/no-result-search.svg" style="width: 300px;">
          <h4 class="mt-4 mb-5 text-primary text-center h2">Aucun résultat</h4>
          <a class="btn btn-primary btn-lg" routerLink="/calculations/create"><i class="fa fa-plus"></i> Créer un nouveau
        calcul</a>
      </td>
    </tr>
  </tbody>
}
<tbody class="list">
  @for (result of this.getResults(); track result) {
    <tr>
      <td (click)="calculationClicked(result)">{{ result.title }}</td>
      <td (click)="calculationClicked(result)">{{ getKeynameText(result.calculationKeyname) }}</td>
      <td (click)="calculationClicked(result)">
        <span [class.bg-danger]="result.status === 'ERROR'"
          [class.bg-light]="result.status === 'CREATED'"
          [class.bg-success]="result.status === 'COMPLETED'"
          [class.bg-warning]="result.status === 'IN_PROGRESS'"
          class="badge rounded-pill bg-warning">{{ getStatusText(result.status) }}
        </span>
      </td>
      <td (click)="calculationClicked(result)">{{ getLastModifiedText(result) }}</td>
      <td>
        <div class="dropdown">
          <a aria-expanded="false" aria-haspopup="true" class="dropdown-ellipses dropdown-toggle"
            data-bs-toggle="dropdown"
            href="#" role="button">
            <i class="fas fa-ellipsis-v"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-end mt-3">
            <a (click)="$event.preventDefault()" class="dropdown-item" href="#">
              <i class="fas fa-fw fa-cloud-download me-2"></i> Exporter le calcul
            </a>
            <a (click)="$event.preventDefault(); tryDuplicate(result.id)" class="dropdown-item" href="#">
              <i class="fas fa-fw fa-copy me-2"></i> Dupliquer le calcul
            </a>
            <hr class="dropdown-divider">
            <a (click)="$event.preventDefault(); tryDelete(result.id)" class="dropdown-item text-danger" href="#">
              <i class="fas fa-fw fa-trash-alt me-2"></i> Supprimer ce calcul
            </a>
          </div>
        </div>
      </td>
    </tr>
  }
</tbody>
</app-table>

